import React, { useState, useEffect, useRef } from 'react';
import Hero from '../components/Hero';
import Captcha from '../components/Captcha';
import apiService from '../services/api';
import { useLanguage } from '../contexts/LanguageContext';

const Contato = () => {
  const { t } = useLanguage();

  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    ddi: '+245',
    telefone: '',
    assunto: '',
    mensagem: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [isDdiDropdownOpen, setIsDdiDropdownOpen] = useState(false);
  const [ddiSearch, setDdiSearch] = useState('');
  const [emailError, setEmailError] = useState('');
  const ddiDropdownRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleTelefoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove tudo que não é dígito
    setFormData(prev => ({
      ...prev,
      telefone: value
    }));
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setFormData(prev => ({
      ...prev,
      email: value
    }));

    // Validação de email em tempo real
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (value && !emailRegex.test(value)) {
      setEmailError(t('contato.form.fields.email.error'));
    } else {
      setEmailError('');
    }
  };

  const ddiOptions = [
    { value: '+245', label: '🇬🇼 +245' },
    { value: '+55', label: '🇧🇷 +55' },
    { value: '+351', label: '🇵🇹 +351' },
    { value: '+33', label: '🇫🇷 +33' },
    { value: '+49', label: '🇩🇪 +49' },
    { value: '+44', label: '🇬🇧 +44' },
    { value: '+1', label: '🇺🇸 +1' },
    { value: '+34', label: '🇪🇸 +34' },
    { value: '+39', label: '🇮🇹 +39' },
    { value: '+31', label: '🇳🇱 +31' },
    { value: '+32', label: '🇧🇪 +32' },
    { value: '+41', label: '🇨🇭 +41' },
    { value: '+46', label: '🇸🇪 +46' },
    { value: '+47', label: '🇳🇴 +47' },
    { value: '+45', label: '🇩🇰 +45' },
    { value: '+358', label: '🇫🇮 +358' },
    { value: '+43', label: '🇦🇹 +43' },
    { value: '+48', label: '🇵🇱 +48' },
    { value: '+420', label: '🇨🇿 +420' },
    { value: '+36', label: '🇭🇺 +36' },
    { value: '+40', label: '🇷🇴 +40' },
    { value: '+359', label: '🇧🇬 +359' },
    { value: '+385', label: '🇭🇷 +385' },
    { value: '+386', label: '🇸🇮 +386' },
    { value: '+421', label: '🇸🇰 +421' },
    { value: '+370', label: '🇱🇹 +370' },
    { value: '+371', label: '🇱🇻 +371' },
    { value: '+372', label: '🇪🇪 +372' },
    { value: '+7', label: '🇷🇺 +7' },
    { value: '+86', label: '🇨🇳 +86' },
    { value: '+81', label: '🇯🇵 +81' },
    { value: '+82', label: '🇰🇷 +82' },
    { value: '+91', label: '🇮🇳 +91' },
    { value: '+61', label: '🇦🇺 +61' },
    { value: '+64', label: '🇳🇿 +64' },
    { value: '+27', label: '🇿🇦 +27' },
    { value: '+20', label: '🇪🇬 +20' },
    { value: '+234', label: '🇳🇬 +234' },
    { value: '+254', label: '🇰🇪 +254' },
    { value: '+212', label: '🇲🇦 +212' },
    { value: '+213', label: '🇩🇿 +213' },
    { value: '+216', label: '🇹🇳 +216' },
    { value: '+218', label: '🇱🇾 +218' },
    { value: '+220', label: '🇬🇲 +220' },
    { value: '+221', label: '🇸🇳 +221' },
    { value: '+222', label: '🇲🇷 +222' },
    { value: '+223', label: '🇲🇱 +223' },
    { value: '+224', label: '🇬🇳 +224' },
    { value: '+225', label: '🇨🇮 +225' },
    { value: '+226', label: '🇧🇫 +226' },
    { value: '+227', label: '🇳🇪 +227' },
    { value: '+228', label: '🇹🇬 +228' },
    { value: '+229', label: '🇧🇯 +229' },
    { value: '+230', label: '🇲🇺 +230' },
    { value: '+231', label: '🇱🇷 +231' },
    { value: '+232', label: '🇸🇱 +232' },
    { value: '+233', label: '🇬🇭 +233' },
    { value: '+235', label: '🇹🇩 +235' },
    { value: '+236', label: '🇨🇫 +236' },
    { value: '+237', label: '🇨🇲 +237' },
    { value: '+238', label: '🇨🇻 +238' },
    { value: '+239', label: '🇸🇹 +239' },
    { value: '+240', label: '🇬🇶 +240' },
    { value: '+241', label: '🇬🇦 +241' },
    { value: '+242', label: '🇨🇬 +242' },
    { value: '+243', label: '🇨🇩 +243' },
    { value: '+244', label: '🇦🇴 +244' },
    { value: '+246', label: '🇮🇴 +246' },
    { value: '+247', label: '🇦🇨 +247' },
    { value: '+248', label: '🇸🇨 +248' },
    { value: '+249', label: '🇸🇩 +249' },
    { value: '+250', label: '🇷🇼 +250' },
    { value: '+251', label: '🇪🇹 +251' },
    { value: '+252', label: '🇸🇴 +252' },
    { value: '+253', label: '🇩🇯 +253' },
    { value: '+255', label: '🇹🇿 +255' },
    { value: '+256', label: '🇺🇬 +256' },
    { value: '+257', label: '🇧🇮 +257' },
    { value: '+258', label: '🇲🇿 +258' },
    { value: '+260', label: '🇿🇲 +260' },
    { value: '+261', label: '🇲🇬 +261' },
    { value: '+262', label: '🇷🇪 +262' },
    { value: '+263', label: '🇿🇼 +263' },
    { value: '+264', label: '🇳🇦 +264' },
    { value: '+265', label: '🇲🇼 +265' },
    { value: '+266', label: '🇱🇸 +266' },
    { value: '+267', label: '🇧🇼 +267' },
    { value: '+268', label: '🇸🇿 +268' },
    { value: '+269', label: '🇰🇲 +269' },
    { value: '+290', label: '🇸🇭 +290' },
    { value: '+291', label: '🇪🇷 +291' },
    { value: '+297', label: '🇦🇼 +297' },
    { value: '+298', label: '🇫🇴 +298' },
    { value: '+299', label: '🇬🇱 +299' }
  ];

  // Filtrar DDIs baseado na pesquisa
  const filteredDdiOptions = ddiOptions.filter(option =>
    option.value.includes(ddiSearch) ||
    option.label.toLowerCase().includes(ddiSearch.toLowerCase())
  );

  const handleDdiSelect = (ddi) => {
    setFormData(prev => ({
      ...prev,
      ddi: ddi.value
    }));
    setDdiSearch('');
    setIsDdiDropdownOpen(false);
  };

  const handleDdiSearchChange = (e) => {
    setDdiSearch(e.target.value);
    setIsDdiDropdownOpen(true);
  };

  // Encontrar a bandeira do DDI selecionado
  const getSelectedDdiFlag = () => {
    const selectedOption = ddiOptions.find(option => option.value === formData.ddi);
    return selectedOption ? selectedOption.label.split(' ')[0] : '🇬🇼';
  };

  // Fechar dropdown quando clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ddiDropdownRef.current && !ddiDropdownRef.current.contains(event.target)) {
        setIsDdiDropdownOpen(false);
        setDdiSearch('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Verificar se o CAPTCHA foi resolvido
    if (!isCaptchaVerified) {
      setSubmitStatus('captcha-error');
      return;
    }

    // Verificar se há erro de email
    if (emailError) {
      setSubmitStatus('email-error');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Preparar dados para envio
      const contatoData = {
        nome_completo: formData.nome,
        email: formData.email,
        telefone: formData.telefone ? `${formData.ddi} ${formData.telefone}` : '',
        assunto: formData.assunto,
        mensagem: formData.mensagem
      };

      const response = await apiService.sendContato(contatoData);

      if (response) {
      setSubmitStatus('success');
      setFormData({
        nome: '',
        email: '',
          ddi: '+245',
        telefone: '',
        assunto: '',
        mensagem: ''
      });
        setEmailError('');
        setDdiSearch('');
        setIsDdiDropdownOpen(false);
        setIsCaptchaVerified(false); // Reset CAPTCHA
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Erro ao enviar formulário de contato:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const informacoesContato = t('contato.info.items');


  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <Hero
        title={t('contato.hero.title')}
        subtitle={t('contato.hero.subtitle')}
        description={t('contato.hero.description')}
        showButtons={false}
      />

      {/* Informações de Contato */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-emerald-100 rounded-full mb-6">
              <span className="text-emerald-600 text-sm font-medium">{t('contato.info.badge')}</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              <span className="block">{t('contato.info.title')}</span>
              <span className="block bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                {t('contato.info.titleHighlight')}
              </span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('contato.info.description')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {informacoesContato.map((info, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-emerald-200 text-center">
                <div className="text-5xl mb-6 group-hover:scale-110 transition-transform duration-300">
                  {info.icone}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-emerald-600 transition-colors duration-300">
                  {info.title}
                </h3>
                <p className="text-lg font-medium text-gray-700 mb-2">
                  {info.description}
                </p>
                <p className="text-sm text-gray-500">
                  {info.details}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Formulário de Contato */}
      <section className="py-20 bg-gradient-to-br from-slate-50 to-emerald-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Formulário */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="space-y-4 mb-8">
                <div className="inline-flex items-center px-4 py-2 bg-emerald-100 rounded-full">
                  <span className="text-emerald-600 text-sm font-medium">{t('contato.form.badge')}</span>
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                  {t('contato.form.title')}
                </h2>
                <p className="text-lg text-gray-600">
                  {t('contato.form.description')}
                </p>
                </div>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-2">
                      {t('contato.form.fields.nome.label')}
                    </label>
                    <input
                      type="text"
                      id="nome"
                      name="nome"
                      value={formData.nome}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200"
                      placeholder={t('contato.form.fields.nome.placeholder')}
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                      {t('contato.form.fields.email.label')}
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleEmailChange}
                      required
                      className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200 ${
                        emailError ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder={t('contato.form.fields.email.placeholder')}
                    />
                    {emailError && (
                      <p className="text-red-500 text-sm mt-1">{emailError}</p>
                    )}
                  </div>
                </div>

                  <div>
                    <label htmlFor="telefone" className="block text-sm font-medium text-gray-700 mb-2">
                    {t('contato.form.fields.telefone.label')}
                    </label>
                  <div className="flex space-x-2">
                    <div className="relative w-24" ref={ddiDropdownRef}>
                      <input
                        type="text"
                        value={ddiSearch || formData.ddi}
                        onChange={handleDdiSearchChange}
                        onFocus={() => setIsDdiDropdownOpen(true)}
                        className={`w-full py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200 bg-white text-sm ${ddiSearch ? 'px-3' : 'pl-10 pr-3'}`}
                        placeholder={formData.ddi}
                      />
                      {!ddiSearch && (
                        <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                          <span className="text-lg">{getSelectedDdiFlag()}</span>
                        </div>
                      )}
                      {isDdiDropdownOpen && (
                        <div className="absolute top-full left-0 right-0 bg-white border border-gray-300 rounded-lg shadow-lg z-50 max-h-60 overflow-y-auto">
                          {filteredDdiOptions.length > 0 ? (
                            filteredDdiOptions.map((option) => (
                              <div
                                key={option.value}
                                onClick={() => handleDdiSelect(option)}
                                className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm flex items-center"
                              >
                                <span className="mr-2">{option.label.split(' ')[0]}</span>
                                <span>{option.value}</span>
                              </div>
                            ))
                          ) : (
                            <div className="px-3 py-2 text-sm text-gray-500">
                              {t('contato.form.fields.telefone.noResults')}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <input
                      type="tel"
                      id="telefone"
                      name="telefone"
                      value={formData.telefone}
                      onChange={handleTelefoneChange}
                      required
                      className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200"
                      placeholder={t('contato.form.fields.telefone.placeholder')}
                      maxLength="15"
                    />
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    {t('contato.form.fields.telefone.help')}
                  </p>
                  </div>

                  <div>
                    <label htmlFor="assunto" className="block text-sm font-medium text-gray-700 mb-2">
                      {t('contato.form.fields.assunto.label')}
                    </label>
                    <select
                      id="assunto"
                      name="assunto"
                      value={formData.assunto}
                      onChange={handleInputChange}
                      required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200"
                    >
                      <option value="">{t('contato.form.fields.assunto.placeholder')}</option>
                      <option value="parceria">{t('contato.form.fields.assunto.options.parceria')}</option>
                    <option value="consultoria">{t('contato.form.fields.assunto.options.consultoria')}</option>
                    <option value="pesquisa">{t('contato.form.fields.assunto.options.pesquisa')}</option>
                    <option value="colaboracao">{t('contato.form.fields.assunto.options.colaboracao')}</option>
                    <option value="informacoes">{t('contato.form.fields.assunto.options.informacoes')}</option>
                      <option value="outro">{t('contato.form.fields.assunto.options.outro')}</option>
                    </select>
                </div>

                <div>
                  <label htmlFor="mensagem" className="block text-sm font-medium text-gray-700 mb-2">
                    {t('contato.form.fields.mensagem.label')}
                  </label>
                  <textarea
                    id="mensagem"
                    name="mensagem"
                    value={formData.mensagem}
                    onChange={handleInputChange}
                    required
                    rows={6}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors duration-200"
                    placeholder={t('contato.form.fields.mensagem.placeholder')}
                  />
                </div>

                {/* CAPTCHA */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {t('contato.form.fields.captcha.label')}
                  </label>
                  <Captcha
                    onVerify={setIsCaptchaVerified}
                    onError={(error) => console.log('CAPTCHA Error:', error)}
                  />
                </div>

                {/* Mensagens de Feedback */}
                {submitStatus === 'success' && (
                  <div className="p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                    <div className="flex items-center">
                      <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      {t('contato.form.messages.success')}
                    </div>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                    <div className="flex items-center">
                      <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                      </svg>
                      {t('contato.form.messages.error')}
                    </div>
                  </div>
                )}

                {submitStatus === 'captcha-error' && (
                  <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                    <div className="flex items-center">
                      <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                      </svg>
                      {t('contato.form.messages.captchaError')}
                    </div>
                  </div>
                )}

                {submitStatus === 'email-error' && (
                  <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                    <div className="flex items-center">
                      <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                      </svg>
                      {t('contato.form.messages.emailError')}
                    </div>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting || !isCaptchaVerified || emailError}
                  className={`w-full px-8 py-4 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl ${
                    isSubmitting || !isCaptchaVerified || emailError
                      ? 'bg-gray-400 cursor-not-allowed'
                      : 'bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700'
                  }`}
                >
                  {isSubmitting ? t('contato.form.buttons.sending') :
                   !isCaptchaVerified ? t('contato.form.buttons.captchaRequired') :
                   emailError ? t('contato.form.buttons.emailError') :
                   t('contato.form.buttons.default')}
                </button>
              </form>
            </div>

            {/* Informações Adicionais */}
            <div className="space-y-8">
            <div>
                <div className="space-y-4 mb-8">
                  <div className="inline-flex items-center px-4 py-2 bg-emerald-100 rounded-full">
                    <span className="text-emerald-600 text-sm font-medium">{t('contato.additional.badge')}</span>
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                    {t('contato.additional.title')}
                  </h2>
                </div>

                {/* Horários */}
                <div className="bg-gradient-to-br from-slate-50 to-emerald-50 rounded-2xl p-8 mb-8 border border-gray-100">
                  <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                    <span className="text-2xl mr-3">🕒</span>
                    {t('contato.additional.hours.title')}
                  </h3>
                  <div className="space-y-4">
                    <div className="flex justify-between items-center py-2">
                      <span className="text-gray-700 font-medium">{t('contato.additional.hours.weekdays')}</span>
                      <span className="text-gray-600">{t('contato.additional.hours.weekdaysTime')}</span>
                    </div>
                    <div className="flex justify-between items-center py-2">
                      <span className="text-gray-700 font-medium">{t('contato.additional.hours.saturday')}</span>
                      <span className="text-gray-600">{t('contato.additional.hours.saturdayTime')}</span>
                    </div>
                    <div className="flex justify-between items-center py-2">
                      <span className="text-gray-700 font-medium">{t('contato.additional.hours.sunday')}</span>
                      <span className="text-gray-600">{t('contato.additional.hours.sundayTime')}</span>
                    </div>
                  </div>
                  <div className="mt-6 p-4 bg-emerald-100 rounded-lg">
                    <p className="text-sm text-emerald-800 font-medium">
                      <span className="text-lg mr-2">🚨</span>
                      {t('contato.additional.hours.emergency')}
                    </p>
                  </div>
                </div>

                {/* Tempo de Resposta */}
                <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
                  <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                    <span className="text-2xl mr-3">⚡</span>
                    {t('contato.additional.response.title')}
                  </h3>
                  <div className="space-y-4">
                    <div className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-emerald-500 rounded-full mt-2 flex-shrink-0"></div>
                      <div>
                        <p className="font-medium text-gray-900">{t('contato.additional.response.email.title')}</p>
                        <p className="text-sm text-gray-600">{t('contato.additional.response.email.description')}</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                      <div>
                        <p className="font-medium text-gray-900">{t('contato.additional.response.phone.title')}</p>
                        <p className="text-sm text-gray-600">{t('contato.additional.response.phone.description')}</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-purple-500 rounded-full mt-2 flex-shrink-0"></div>
                      <div>
                        <p className="font-medium text-gray-900">{t('contato.additional.response.emergency.title')}</p>
                        <p className="text-sm text-gray-600">{t('contato.additional.response.emergency.description')}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-br from-slate-900 via-teal-900 to-emerald-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-emerald-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-teal-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-1000"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            {t('contato.cta.title')}
          </h2>
          <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto">
            {t('contato.cta.description')}
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <a
              href="mailto:contato@conexaosaude.org"
              className="group bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-8 py-4 rounded-xl font-semibold hover:from-emerald-600 hover:to-teal-700 transition-all duration-300 shadow-2xl hover:shadow-emerald-500/25 flex items-center justify-center space-x-2"
            >
              <span>{t('contato.cta.buttons.email')}</span>
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </a>
            <a
              href="tel:+245966065555"
              className="group border-2 border-white/30 text-white px-8 py-4 rounded-xl font-semibold hover:bg-white hover:text-slate-900 transition-all duration-300 backdrop-blur-sm flex items-center justify-center space-x-2"
            >
              <span>{t('contato.cta.buttons.phone')}</span>
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contato;